export default "__VITE_ASSET__CPZJl7jR__"